import kitchenEquipment from '../images/kitchen-equipment.jpg';
import repairService from '../images/repair-service.jpg';

export const mockListings = {
  1: {
    id: 1,
    name: 'Expert Kitchen Repairs',
    rating: 4.8,
    reviewCount: 156,
    yearsInBusiness: 15,
    description: 'Professional repair services for all commercial kitchen equipment',
    address: '123 Main St, New York, NY 10001',
    phone: '(212) 555-0123',
    email: 'contact@expertkitchenrepairs.com',
    website: 'https://expertkitchenrepairs.com',
    services: [
      'Emergency Repairs',
      '24/7 Support',
      'All Brands',
      'Preventive Maintenance',
      'Parts Replacement',
      'Equipment Installation',
    ],
    hours: {
      monday: '8:00 AM - 6:00 PM',
      tuesday: '8:00 AM - 6:00 PM',
      wednesday: '8:00 AM - 6:00 PM',
      thursday: '8:00 AM - 6:00 PM',
      friday: '8:00 AM - 6:00 PM',
      saturday: '9:00 AM - 4:00 PM',
      sunday: 'Closed',
    },
    certifications: [
      'Licensed & Insured',
      'Factory Authorized',
      'EPA Certified',
      'CFESA Member',
    ],
    reviews: [
      {
        id: 1,
        author: 'John Smith',
        date: '2024-01-15',
        rating: 5,
        content: 'Excellent service! Fixed our commercial oven quickly and professionally.',
      },
      {
        id: 2,
        author: 'Mary Johnson',
        date: '2024-01-10',
        rating: 5,
        content: 'Very reliable and knowledgeable team. Would highly recommend!',
      },
      {
        id: 3,
        author: 'David Wilson',
        date: '2024-01-05',
        rating: 4,
        content: 'Good service, fair pricing. Will use again.',
      },
    ],
    mainImage: kitchenEquipment,
  },
  2: {
    id: 2,
    name: 'Quick Fix Solutions',
    rating: 4.9,
    reviewCount: 203,
    yearsInBusiness: 12,
    description: 'Fast and reliable commercial kitchen equipment repairs',
    address: '456 Market St, Los Angeles, CA 90012',
    phone: '(323) 555-0123',
    email: 'service@quickfixsolutions.com',
    website: 'https://quickfixsolutions.com',
    services: [
      'Same Day Service',
      'Licensed Technicians',
      'Warranty Support',
      'Equipment Upgrades',
      'Safety Inspections',
      'Commercial Appliance Repair',
    ],
    hours: {
      monday: '7:00 AM - 7:00 PM',
      tuesday: '7:00 AM - 7:00 PM',
      wednesday: '7:00 AM - 7:00 PM',
      thursday: '7:00 AM - 7:00 PM',
      friday: '7:00 AM - 7:00 PM',
      saturday: '8:00 AM - 5:00 PM',
      sunday: 'On Call',
    },
    certifications: [
      'Master Certified Technicians',
      'BBB Accredited',
      'NAFEM Certified',
      'Energy Star Partner',
    ],
    reviews: [
      {
        id: 1,
        author: 'Robert Chen',
        date: '2024-01-20',
        rating: 5,
        content: 'Outstanding service! They saved us during a critical equipment failure.',
      },
      {
        id: 2,
        author: 'Sarah Martinez',
        date: '2024-01-18',
        rating: 5,
        content: 'Very professional and efficient. Great communication throughout.',
      },
      {
        id: 3,
        author: 'James Thompson',
        date: '2024-01-12',
        rating: 5,
        content: 'Best repair service in LA! Always reliable and thorough.',
      },
    ],
    mainImage: repairService,
  },
};